export enum InterviewAudioStatusEnum {
  NEW = 'NEW',
  UPLOADING = 'UPLOADING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type InterviewAudio = {
  id: number
  interviewId: number
  audioFileId?: number
  transcriptText?: string
  transcriptSegments?: string
  summary?: string
  status: InterviewAudioStatusEnum
  createdAt: Date
  updatedAt: Date
}
